export default __webpack_public_path__ + "da1ff0230f47b56ae0e52a2d3e2acb42.svg";